// ── 전화번호 렌더 컴포넌트 ────────────────────────────────────────────────────

import React from 'react';
import { extractPhoneNumbers, getDialLink } from './utils';
import { phoneEmptyStyle, phoneLinksWrapStyle, phoneLinkStyle } from './styles';

// 전화번호 문자열을 파싱해 클릭 가능한 tel: 링크로 렌더링
// 번호가 없으면 raw 텍스트 표시, 아예 비어 있으면 '-' 표시
//   linkStyle/emptyStyle 은 선택 — 안 넘기면 기본 크기 그대로다(목록의 '글자 크게'에서만 넘긴다).
export function PhoneValue({ value, linkStyle, emptyStyle }) {
  const empty = emptyStyle || phoneEmptyStyle;
  const link = linkStyle || phoneLinkStyle;
  const raw = String(value || '').trim();
  if (!raw) return <span style={empty}>-</span>;
  const phones = extractPhoneNumbers(raw);
  if (!phones.length) return <span style={empty}>{raw}</span>;
  return (
    <span style={phoneLinksWrapStyle}>
      {phones.map((phone, idx) => (
        <a key={`${phone.dial}-${idx}`} href={getDialLink(phone.dial)} style={link}>
          {phone.display}
        </a>
      ))}
    </span>
  );
}
